import React, { useState, useEffect } from 'react';
import { Badge,  Col, Form, Image, InputGroup, Modal, Row, Table, Nav, Space, Input } from "react-bootstrap";
import { Button, message, Spin } from 'antd';

import { oneKlicks } from "../../SDK/oneclick";
import "../../assets/styles/dashboard.css";
import AddBannerModal from '../Components/AddBannerModal';
import EditBannerModal from '../Components/EditBannerModal';
import Paginationnew from "../../Uitiles/Paginationnew";
import ImageShow from '../../Uitiles/ImageShow';
import { EditOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';


const BannerNew = () => {
    const [search, setSearch] = useState('');
    const [openAdd, setOpenAdd] = useState(false);
    const [banners, setBanners] = useState([]);
    const [page, setPage] = useState(1);
    const [type, setType] = useState('');
    const [totalPages, setTotalPages] = useState(1);
    const [viewData, setViewData] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [limit, setLimit] = useState(10);
    const [loading, setLoading] = useState(false);
    const [editData, setEditData] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [formValues, setFormValues] = useState({
        name: '',
        description: '',
        status: 'active'
    });

    const bannerTypes = [
        { value: 'hero', label: 'Hero Banner', size: '1920x1080' },
        { value: 'doctor_listing', label: 'Doctor Listing Banner', size: '920x100' },
        { value: 'hospital_listing', label: 'Hospital Listing Banner', size: '920x100' },
        { value: 'right_sidebar', label: 'Right Sidebar Banner', size: '510x400' },
        { value: 'home_page', label: 'Home Page Banner', size: '1920x1080' },
        { value: 'search_page', label: 'Search Page Banner', size: '920x100' },
        { value: 'category_page', label: 'Category Page Banner', size: '1920x1080' },
        { value: 'popup', label: 'Popup Banner', size: '512x512' },
        { value: 'notification', label: 'Notification Banner', size: '920x100' }
    ];

    useEffect(() => {
        fetchBanners();
    }, [page, limit, search, type]);

    const fetchBanners = async () => {
        try {
            setLoading(true);
            const tableSchema = '';
            const tableName = 'banners';
            const conditions = {
                ...(type && { banner_type: type }),
            };
            const orderBy = 'id DESC';
            const searchConditions = search ? { name: { $like: `%${search}%` } } : {};
            const pagination = { page: page, limit: limit };
            const margedata = [];
            console.log("banner new conditions", conditions);
            console.log("banner new searchConditions", searchConditions);
            console.log("banner new pagination", pagination);
            console.log("banner new margedata", margedata);
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, searchConditions, pagination, margedata);
            console.log("banner new response", response);
            if (response.success) {
                setBanners(response.data);
                setTotalPages(response.totalPages);
            } else {
                setBanners([]);
                console.log("error", response);
            }
        } catch (error) {
            console.log("error", error);
            setBanners([]);
        } finally {
            setLoading(false);
        }
    };

    function StatusBadge({ status }) {
        const variant =
            status === "active"
                ? "success"
                : status === "draft"
                    ? "warning"
                    : "secondary";

        // Capitalize first letter
        const formattedStatus =
            status && status.length > 0
                ? status.charAt(0).toUpperCase() + status.slice(1)
                : "";

        return (
            <Badge bg={variant} style={{ color: "#fff", padding: "4px 8px" }}>
                {formattedStatus}
            </Badge>
        );
    }


    const openView = (template) => {
        console.log("openView", template);
        setViewData(template);
        setShowViewModal(true);
    };

    const handleDelete = async (template) => {
        if (window.confirm('Are you sure you want to delete this template?')) {
            try {
                // TODO: Implement delete functionality
                const tableSchema = '';
                const tableName = 'banners';
                const conditions = { id: template.id };
                const response = await oneKlicks.delete(tableSchema, tableName, conditions);
                if (response.success) {
                    message.success('Banner deleted successfully');
                    fetchBanners();
                }else{
                    message.error('Failed to delete banner');
                }
                
            } catch (error) {
                console.log('Error deleting template:', error);
                message.error('Failed to delete template');
            }
        }
    };

    const handleShowEditModal = (record) => {
        setEditData(record);
        setShowEditModal(true);
        setOpenAdd(true);
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2  mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Templates</h5>
                                <Badge bg="info">SMS / Email / WhatsApp</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 5 }}>
                                <div className="d-flex align-items-center gap-2">
                                    <InputGroup className="p-0 mr-2" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                        <Form.Control
                                            placeholder="Search..."
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                    </InputGroup>
                                    <Form.Select
                                        className='form-control'
                                        value={type}
                                        onChange={(e) => setType(e.target.value)}
                                    >
                                        <option value="" defaultValue>All</option>
                                        {bannerTypes.map((type) => (
                                            <option key={type.value} value={type.value}>{type.label}</option>
                                        ))}
                                    </Form.Select>
                                </div>

                                <Button variant="primary" style={{ width: 150 }} onClick={() => setOpenAdd(true)}>+ Add Banner</Button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table >
                                <thead>
                                    <tr>
                                        <th >ID</th>
                                        <th>Banner Name</th>
                                        <th>Location Type</th>
                                        <th>Banner Type</th>
                                        <th>End Date</th>
                                        <th >Image</th>
                                        <th >Status</th>
                                        <th >Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {banners.length === 0 && (
                                        <tr>
                                            <td colSpan={7} className="text-center text-muted py-4">No templates found.</td>
                                        </tr>
                                    )}
                                    {banners.map((t) => (
                                        <tr key={t.id}>
                                            <td data-label="ID">#{t.id}</td>
                                            <td data-label="Banner Name">{t.banner_name}</td>
                                            <td data-label="Location Type">
                                                {t.location_type
                                                    ? t.location_type
                                                        .split("_")
                                                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                                        .join(" ")
                                                    : "-"}
                                            </td>
                                            <td data-label="Banner Type">
                                                {t.banner_type
                                                    ? t.banner_type
                                                        .split("_")
                                                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                                        .join(" ")
                                                    : "-"}
                                            </td>
                                            <td data-label="End Date">{t.end_date}</td>
                                            <td data-label="Image" style={{ maxWidth: '100px' }}>
                                                <ImageShow url={t.imageUrl} width={0} style={{ objectFit: 'cover' }} />
                                            </td>
                                            <td data-label="Status"><StatusBadge status={t.status} /></td>
                                            <td data-label="Actions">
                                                <div style={{ display: 'flex', flexDirection: 'row', gap: '6px', alignItems: 'center', flexWrap: 'nowrap', justifyContent: 'flex-end' }}>
                                                    <Button href="#" className="dc-update-servicesss fit-content" onClick={(e) => {
                                                        e.preventDefault();
                                                        openView(t);
                                                    }} >
                                                        <EyeOutlined style={{ fontSize: '11px', marginRight: '4px' }} />
                                                    </Button>
                                                    <Button href="#" className="dc-update-servicesss btn-light" onClick={(e) => {
                                                        e.preventDefault();
                                                        handleShowEditModal(t);
                                                    }} >
                                                        <EditOutlined style={{ fontSize: '11px', marginRight: '4px' }} />
                                                    </Button>
                                                    <Button href="#" className="dc-update-servicesss btn-danger" onClick={(e) => {
                                                        e.preventDefault();
                                                        handleDelete(t);
                                                    }} >
                                                        <DeleteOutlined style={{ fontSize: '11px', marginRight: '4px' }} />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <Paginationnew
                            currentPage={page}
                            totalPages={totalPages}
                            handlePageChange={setPage}
                        />
                    </div>
                </div>

                {/* Modals */}
                {openAdd && (
                    <AddBannerModal
                        visible={openAdd}
                        onCancel={() => setOpenAdd(false)}
                        onSuccess={() => {
                            setOpenAdd(false);
                            fetchBanners();
                        }}
                        isEdit={false}
                        editData={null}
                    />
                )}

                {showEditModal && editData && (
                    <AddBannerModal
                        visible={showEditModal}
                        onCancel={() => setShowEditModal(false)}
                        onSuccess={() => {
                            setShowEditModal(false);
                            fetchBanners();
                        }}
                        isEdit={true}
                        editData={editData}
                    />
                )}

                {showViewModal && viewData && (
                    // OPEN VIEW MODAL

                    <Modal show={showViewModal} onHide={() => setShowViewModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Banner Details</Modal.Title>
                            <Button onClick={() => setShowViewModal(false)}>Close</Button>
                        </Modal.Header>
                        <Modal.Body>
                            {viewData && (
                                <div>
                                    <ImageShow url={viewData.imageUrl} width={320} style={{ objectFit: 'cover' }} />
                                </div>
                            )}
                        </Modal.Body>
                    </Modal>
                )}

            </div>
        </div>
    );
};

export default BannerNew;
